
/**
 * 콘텐츠 타입
 */
export type CourseDraftUpdateSectionsItemLecturesItemContentType = typeof CourseDraftUpdateSectionsItemLecturesItemContentType[keyof typeof CourseDraftUpdateSectionsItemLecturesItemContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseDraftUpdateSectionsItemLecturesItemContentType = {
  VIDEO: 'VIDEO',
  MARKDOWN: 'MARKDOWN',
  INTERACTIVE: 'INTERACTIVE',
  QUIZ: 'QUIZ',
} as const;
